import { CertificationIcon } from 'foundations-assets/icons/components/CertificationIcon';
import { DiamondIcon } from 'foundations-assets/icons/components/DiamondIcon';
import { FavoriteHollowIcon } from 'foundations-assets/icons/components/FavoriteHollowIcon';
import { TrophyIcon } from 'foundations-assets/icons/components/TrophyIcon';
import unescapedText from 'I18n/utils/unescapedText';
/**
 * @returns `undefined` if `listing` is not a partner
 * @returns `partnerTier` if it exists, otherwise `'none'`
 */
export function getPartnerTier(listing) {
  var _product$partnerTier;
  const product = listing.products[0];
  if ((product === null || product === void 0 ? void 0 : product.productType) !== 'SOLUTIONS_PARTNER_PROFILE') return undefined;
  return (_product$partnerTier = product.partnerTier) !== null && _product$partnerTier !== void 0 ? _product$partnerTier : 'none';
}
export function getPartnerTierContent(tier) {
  switch (tier) {
    case 'elite':
      return {
        badgeUse: 'lorax',
        icon: TrophyIcon,
        iconColor: undefined,
        text: unescapedText('marketplace-embed.card.partnerTiers.elite')
      };
    case 'diamond':
      return {
        badgeUse: 'blue',
        icon: DiamondIcon,
        iconColor: undefined,
        text: unescapedText('marketplace-embed.card.partnerTiers.diamond')
      };
    case 'platinum':
      return {
        badgeUse: 'koala',
        icon: CertificationIcon,
        iconColor: 'fill-accent-blue-default',
        text: unescapedText('marketplace-embed.card.partnerTiers.platinum')
      };
    case 'gold':
      return {
        badgeUse: 'koala',
        icon: FavoriteHollowIcon,
        iconColor: undefined,
        text: unescapedText('marketplace-embed.card.partnerTiers.gold')
      };
    default:
      return undefined;
  }
}